import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e4199b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Banner pagina principala ")
const _hoisted_6 = { class: "banner__upload__area" }
const _hoisted_7 = { class: "row no-wrap items-center q-pa-sm q-gutter-xs" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Alege o imagine")
const _hoisted_9 = {
  key: 1,
  class: "app__label--medium",
  style: {"margin-top":"1rem"}
}
const _hoisted_10 = {
  key: 0,
  class: "banner__link__area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_uploader_add_trigger = _resolveComponent("q-uploader-add-trigger")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_uploader = _resolveComponent("q-uploader")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "image",
                style: {"font-size":"2rem","top":"-3px"},
                color: "primary"
              }),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_q_form, {
      onSubmit: _ctx.onSubmit,
      class: "q-gutter-md",
      style: {"max-width":"640px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_q_uploader, {
            ref: "bannerUploader",
            label: "Incarca imaginea bannerului",
            accept: ".jpg, .jpeg, .png, .gif, .webp, image/*",
            "auto-upload": false,
            color: "grey",
            flat: "",
            "hide-upload-button": true,
            multiple: false,
            style: {"width":"100%","max-width":"600px"},
            onAdded: _ctx.onImageAdded
          }, {
            header: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_7, [
                (scope.isUploading)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 0,
                      class: "q-uploader__spinner"
                    }))
                  : _createCommentVNode("", true),
                (scope.canAddFiles)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      type: "a",
                      icon: "add_box",
                      round: "",
                      dense: "",
                      flat: "",
                      label: "Alege imagine"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_uploader_add_trigger),
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onAdded"]),
          (_ctx.showBanner.length>0)
            ? (_openBlock(), _createBlock(_component_q_img, {
                key: 0,
                src: _ctx.showBanner,
                "spinner-color": "white",
                style: {"width":"100%","max-width":"600px","margin-top":"1rem","border":"1px solid #eee"}
              }, {
                loading: _withCtx(() => [
                  _createVNode(_component_q_spinner_gears, { color: "white" })
                ]),
                _: 1
              }, 8, ["src"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, "Niciun banner incarcat inca."))
        ]),
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.isClickable,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isClickable) = $event)),
          label: "Banner clickabil (redirectioneaza catre un link)",
          color: "teal",
          "true-value": "y",
          "false-value": "n"
        }, null, 8, ["modelValue"]),
        (_ctx.isClickable=='y')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_q_input, {
                outlined: "",
                modelValue: _ctx.linkUrl,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.linkUrl) = $event)),
                label: "Link (https://... sau o ruta interna /...)",
                style: {"max-width":"600px"},
                rules: [
              val => !!val || 'Linkul este obligatoriu cand bannerul este clickabil',
              val => _ctx.isValidLink(val) || 'Link invalid (folositi https://... sau /ruta-interna)'
            ]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_q_toggle, {
                modelValue: _ctx.openInNewTab,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openInNewTab) = $event)),
                label: "Deschide in tab nou",
                color: "primary",
                "true-value": "y",
                "false-value": "n"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_q_btn, {
            loading: _ctx.saving,
            type: "submit",
            color: "primary",
            label: "Salveaza banner",
            icon: "save"
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}